var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-flex"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.colorIcon}},[_vm._v(_vm._s(_vm.getIcon()))]),(_vm.label)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }